import { useWhyDidYouUpdate } from '../../hooks';
import React, { useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaEdit, FaMapMarkerAlt, FaPhone, FaUser, FaBuilding } from 'react-icons/fa';
import { useRootStore } from '../../store';
import { gqlGetCollectionpoint } from './graphql';
import { useLazyQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';

import { CollectionOrdersSection } from './collection-orders-section';
import { StandaloneCollectionsSection } from './standalone-collections-section';
import { Co2ImpactSection } from './co2-impact-section';
import UpdateCollectionPointModal from './cp-modal';

/** Διακριτική πρόσκληση διόρθωσης στοιχείων */
const UpdateDetailsCta = ({ onClick }: { onClick: () => void }) => (
  <div className="home-callout home-callout--muted">
    <p>Τα στοιχεία σας δεν ανταποκρίνονται στην πραγματικότητα;</p>
    <Button
      variant="outline-primary"
      size="sm"
      className="home-cta-btn home-cta-btn--compact"
      onClick={onClick}
    >
      <FaEdit className="mb-1 mr-1" /> Διόρθωση Στοιχείων
    </Button>
  </div>
);

/** Στοιχεία σημείου συλλογής σε σύγχρονο grid */
const ProfileDetails = ({ data }: { data: any }) => {
  const address = [
    data.addressLine1,
    data.addressLine2,
    data.addressArea,
    data.addressCity,
    data.postalCode,
  ]
    .filter(Boolean)
    .join(', ');

  const phones = [data.phone, data.mobile].filter(Boolean).join(', ');

  return (
    <div className="home-profile-grid">
      <div className="home-profile-item">
        <FaMapMarkerAlt />
        <div>
          <label>Διεύθυνση</label>
          <span>{address}</span>
        </div>
      </div>
      <div className="home-profile-item">
        <FaPhone />
        <div>
          <label>Τηλέφωνα</label>
          <span>{phones || '—'}</span>
        </div>
      </div>
      {data.contactPerson && (
        <div className="home-profile-item">
          <FaUser />
          <div>
            <label>Επικοινωνία</label>
            <span>{data.contactPerson}</span>
          </div>
        </div>
      )}
      <div className="home-profile-item">
        <FaBuilding />
        <div>
          <label>Α.Φ.Μ.</label>
          <span>{data.companyVat || '—'}</span>
          <label className="mt-2">Δ.Ο.Υ.</label>
          <span>{data.companyTaxOffice || '—'}</span>
        </div>
      </div>
    </div>
  );
};

const HomePage = () => {
  const { appStore } = useRootStore();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [textareaValue, setTextareaValue] = useState('');

  // const [showAlert, setShowAlert] = useState(!appStore.stopFormAlert);
  const id = appStore.collectionpointLogin.collectionpointId;
  const [get, { data: rawData }] = useLazyQuery(gqlGetCollectionpoint);
  const data = rawData ? rawData.getCollectionpointById : undefined;

  console.log('[HomePage] invoked with id =', id, 'data =', data);

  //-------------------- Body -------------------------------------------
  //
  /* fetch data */
  useEffect(() => {
    if (id) get({ variables: { id } });
  }, [get, id]);

  //-------------------- Handlers -------------------------------------------
  //

  // const stopFormAlert = () => {
  //   appStore.setStopFormAlert();
  //   setShowAlert(false);
  // };

  // const handleOpenForm = () => {
  //   setShowAlert(false);
  //   window.open(
  //     'https://docs.google.com/forms/d/e/1FAIpQLScOCDJt8CAy03wO8YO7WdHc91up1Gy5omZUyuQgrLZORmcg4Q/viewform',
  //   );
  // };

  //
  //-------------------- Render ----------------------------------------------
  //
  useWhyDidYouUpdate('[HomePage]', { data });

  return (
    <>
      <div className="home-page">
        <Card className="home-main-card shadow-sm mb-4">
          <Card.Body>
            {data ? (
              <>
                <div className="home-welcome">
                  <h2>
                    Καλώς ήρθατε, <span className="home-welcome__name">{data.name}</span>
                  </h2>
                  <span className="home-welcome__sub">Στοιχεία καταχωρημένου σημείου συλλογής</span>
                </div>
                <ProfileDetails data={data} />
                <UpdateDetailsCta onClick={() => setShowModal(true)} />
              </>
            ) : (
              <p className="text-center text-muted py-3">Φόρτωση στοιχείων...</p>
            )}
          </Card.Body>
        </Card>

        <Co2ImpactSection id={id} />
        <CollectionOrdersSection id={id} />
        <StandaloneCollectionsSection id={id} />
      </div>

      {data && (
        <UpdateCollectionPointModal
          show={showModal}
          onClose={() => setShowModal(false)}
          initialName={data.name}
          id={data.id}
          onUpdated={() => get({ variables: { id } })}
          initialAddressLine1={data.addressLine1 ?? ''}
          initialAddressLine2={data.addressLine2 ?? ''}
          initialPostalCode={data.postalCode ?? ''}
          initialAddressArea={data.addressArea ?? ''}
          initialAddressCity={data.addressCity ?? ''}
          initialAddressNomos={data.addressNomos ?? ''}
          initialAddressDistrict={data.addressDistrict ?? ''}
          initialContactPerson={data.contactPerson ?? ''}
          initialPhone={data.phone ?? ''}
          initialMobile={data.mobile ?? ''}
          initialFax={data.fax ?? ''}
          initialEmail={data.email ?? ''}
          initialCompanyVat={data.companyVat ?? ''}
          initialCompanyTaxOffice={data.companyTaxOffice ?? ''}
          initialImaCode={data.imaCode ?? ''}
          initialRegionId={data.region?.id?.toString() ?? ''}
        />
      )}
    </>
  );
};

export default HomePage;
HomePage.whyDidYouRender = true;
